import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';

import ProjectControl from './pages/ProjectControl';
import Documents from './pages/Documents';
import Extract from './pages/Extract';
import Packages from './pages/Packages';
import PackageDetail from './pages/PackageDetail';
import RFQ from './pages/RFQ';
import BidLeveling from './pages/BidLeveling';
import AwardMemo from './pages/AwardMemo';
import PostAward from './pages/PostAward';
import Suppliers from './pages/Suppliers';
import WorkQueue from './pages/WorkQueue';
import Login from './pages/Login';
import Register from './pages/Register';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }>
          <Route index element={<Navigate to="/control" replace />} />
          <Route path="control" element={<ProjectControl />} />
          <Route path="documents" element={<Documents />} />
          <Route path="extract" element={<Extract />} />
          <Route path="packages" element={<Packages />} />
          <Route path="packages/:id" element={<PackageDetail />} />
          <Route path="rfq" element={<RFQ />} />
          <Route path="bid-leveling" element={<BidLeveling />} />
          <Route path="award/:packageId" element={<AwardMemo />} />
          <Route path="post-award" element={<PostAward />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="work-queue" element={<WorkQueue />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;